export default __webpack_public_path__ + "static/media/jd-management.ba4fa000.svg";